import { render, staticRenderFns } from "./SaveFranchisee.vue?vue&type=template&id=17e5b4f7"
import script from "./SaveFranchisee.vue?vue&type=script&lang=js"
export * from "./SaveFranchisee.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports